import React from "react";
import { Textarea } from "@/components/ui/textarea";

export const BIO_MAX_WORDS = 150;
export const BIO_PLACEHOLDERS = {
  theatre: "Jordan Rivera (Emily Webb) is a junior and is thrilled to be part of this production! Favorite past roles include Annie (Molly) and Into the Woods (Little Red). Offstage, Jordan dances with the school dance team and loves painting and baking. Jordan thanks family, friends and the directors for their endless support. Enjoy the show!",
  spirit: "Taylor Jenkins (Junior) is in her second year on the Varsity Dance Team. She has trained in jazz, lyrical, and hip-hop for over eight years. Outside of school, Taylor dances competitively at [Local Dance Studio Name] and assists with youth classes. She thanks her family, coaches, and teammates for their constant support and is thrilled to perform under the Friday night lights!",
};

export const wordCount = (t) => (t || "").trim().split(/\s+/).filter(Boolean).length;
export const overLimit = (t) => wordCount(t) > BIO_MAX_WORDS;

// Bio textarea with a light grey program-specific example placeholder and a live word counter.
export default function BioEditor({ value, onChange, program = "spirit", testId = "bio-textarea", autoFocus }) {
  const n = wordCount(value);
  const over = n > BIO_MAX_WORDS;
  return (
    <div>
      <Textarea rows={7} value={value} onChange={(e) => onChange(e.target.value)} autoFocus={autoFocus}
        placeholder={BIO_PLACEHOLDERS[program] || BIO_PLACEHOLDERS.spirit} data-testid={testId}
        className={`resize-y text-sm leading-relaxed placeholder:text-slate-400 ${over ? "border-red-300 focus-visible:ring-red-400" : ""}`} />
      <div className="mt-1.5 flex items-center justify-between text-xs">
        <span className="text-slate-400">Write in the third person, the way it should read in the program.</span>
        <span className={`tabular-nums font-semibold ${over ? "text-red-600" : n > BIO_MAX_WORDS * 0.9 ? "text-amber-600" : "text-slate-500"}`} data-testid={`${testId}-count`}>
          {n} / {BIO_MAX_WORDS} words
        </span>
      </div>
    </div>
  );
}
